import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TweenMax, TimelineMax } from 'gsap';
import debounce from 'lodash/debounce';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import ScrollMagicFn from '@/utils/ScrollMagic';
import EFVideoModal from '@/components/UI/EFVideoModal';
import BsFillTriangleFill from '@/components/UI/svg/Icons/BsFillTriangleFill';
import EFVideo from '@/components/UI/EFVideo';

const PageConPc = dynamic(() => import('@/components/productRiver/riverpro/indexDynamic'), {
    ssr: true,
});
export default function GsapB() {
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }
    const { useState, useEffect, useRef, useLang, useRouter, gtm } = useGlobal();
    const [offsetTop, setOffsetTop] = useState('-124px');
    const ref = useRef(null);
    const videoRef1 = useRef(null);
    const { t } = useLang('riverproportablepowerstation');
    const { locale } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const [showField, setShowField] = useState(false);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/3cIMpmRHbGo',
        cn: {
            SD: 'https://videos.ecoflow.com/5ae9d6d62cef43ccb9f454303686faab/f11e3203028443c39427617338128728-a6a7baf7ef7b18b463fed19f321bf1f3-fd.mp4',
            HD: 'https://videos.ecoflow.com/5ae9d6d62cef43ccb9f454303686faab/f11e3203028443c39427617338128728-d80b2a6a565bb18e6ac7f897a3f09096-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/efdc6b4-182edd3d95a-0004-9c91-e6d-40030.mp4',
        },
    };

    const videoMap: any = {
        us: {
            kv: ['/video/riverpro/kv.webm', '/video/riverpro/kv.mp4'],
            number: ['/video/riverpro/number.webm', '/video/riverpro/number.mp4'],
        },
        au: {
            kv: ['/video/riverpro/kv_au.webm', '/video/riverpro/kv_au.mp4'],
            number: ['/video/riverpro/number_au.webm', '/video/riverpro/number_au.mp4'],
        },
        uk: {
            kv: ['/video/riverpro/kv_uk.webm', '/video/riverpro/kv_uk.mp4'],
            number: ['/video/riverpro/number_uk.webm', '/video/riverpro/number_uk.mp4'],
        },
        de: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        fr: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        cn: {
            kv: ['/video/riverpro/kv_cn.webm', '/video/riverpro/kv_cn.mp4'],
            number: ['/video/riverpro/number_cn.webm', '/video/riverpro/number_cn.mp4'],
        },
        it: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        es: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        eu: {
            kv: ['/video/riverpro/kv_eu.webm', '/video/riverpro/kv_eu.mp4'],
            number: ['/video/riverpro/number_eu.webm', '/video/riverpro/number_eu.mp4'],
        },
        za: {
            kv: ['/video/riverpro/kv_za.webm', '/video/riverpro/kv_za.mp4'],
            number: ['/video/riverpro/number_za.webm', '/video/riverpro/number_za.mp4'],
        },
        sa: {
            kv: ['/video/riverpro/kv_uk.webm', '/video/riverpro/kv_uk.mp4'],
            number: ['/video/riverpro/number_uk.webm', '/video/riverpro/number_uk.mp4'],
        },
    };

    const currentVideo = locale in videoMap ? videoMap[locale] : videoMap.us;

    // 视频播放
    useEffect(() => {
        // 首屏文字显示
        setTimeout(() => {
            setShowField(true);
        }, 3000);

        const onReize = debounce(() => {
            const nav: any = document.querySelector('.detail-nav');
            const top = document.documentElement.scrollTop || document.body.scrollTop;
            if (nav) {
                setOffsetTop(`${-(60 + nav.offsetHeight)}px`);
            }
            if (top > -1140) {
                // 处理safari全屏时，视频丢失
                videoRef1.current.play();
            }
        }, 200);
        window.addEventListener('resize', onReize);
        return () => {
            window.removeEventListener('resize', onReize);
        };
    }, []);

    return (
        <div className={`${css.gsapb} gsapb`} ref={ref} style={{ marginTop: offsetTop }}>
            <div className="blockWrapper headerWrapper">
                <div className="video-wrapper">
                    <EFVideo ref={videoRef1} sources={currentVideo.kv} loop={false} />
                    <div className={`watch-field ${showField ? 'show-field' : ''}`}>
                        <h3 className="font-family-extrabold title">{t('river_pro.banner_title')}</h3>
                        <p className="font-family-semibold desc">{t('river_pro.banner_desc')}</p>
                        <button
                            onClick={() => {
                                setShowEFVideoModal(true);
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'video',
                                    title_name: 'EcoFlow RIVER Pro',
                                    position: 'Product Detail_1',
                                });
                            }}
                        >
                            {t('river_pro.watch_video')}
                            <BsFillTriangleFill className="arrow-triangle-right" />
                        </button>
                    </div>
                </div>
            </div>
            <PageConPc />
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
